import styled from "styled-components";

export const StyledOrderedList = styled.ol`
  list-style: none;
  counter-reset: list-counter;
  display: flex;
  flex-direction: column;
  gap: 8px;

  li {
    counter-increment: list-counter;
    display: inline-flex;
  }
  li::before {
    content: counter(list-counter) ". ";
    margin-right: 8px;
    white-space: nowrap;
    line-height: 21.82px;
  }
`;
